import _ from 'lodash';
import { req } from 'vuelidate/lib/validators/common';
import cardValidator from 'card-validator';

export default number => {
  const type = _.get(cardValidator.number(number), 'card.type');
  return !req(number) ||
         number.length < 4 ||
         type === 'master-card' ||
         type === 'discover' ||
         type === 'visa';
};



// WEBPACK FOOTER //
// ./src/components/customValidation/cardType.js